module.exports = __webpack_public_path__ + "img/plan01_girl.329fbfd6.png";